export const tokenConstants = {
    INVALID_TOKEN: 'INVALID_TOKEN',
    REFRESHING_TOKEN: 'REFRESHING_TOKEN',
    TOKEN_REFRESHED: 'TOKEN_REFRESHED',
    RESEND_TOKEN: 'RESEND_TOKEN',
    REFRESH_EXPIRED: 'REFRESH_EXPIRED',
};
